import { dealStore } from '@/models/stores';
import { first } from 'lodash';
import { toJS } from 'mobx';

const useDeal = (dealShortIdOrDealId: string) => {
  const idType =
    first(dealShortIdOrDealId?.split('-'))?.length === 3 ? 'shortId' : 'id';
  const shortId = idType === 'shortId' ? dealShortIdOrDealId : undefined;
  const id = idType === 'id' ? dealShortIdOrDealId : undefined;

  const proxyDeal = shortId
    ? dealStore.getByShortId(shortId)
    : id
      ? dealStore.getById(id)
      : null;

  const deal = toJS(proxyDeal);

  return { deal };
};

export default useDeal;
